import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseClientBillsTotalizerProps<T> = {
  filters: {
    clientId?: string
    branchId?: string
    status?: string
    openedAt?: string
    closedAt?: string
    requiresAttention?: boolean
    showDescendants?: boolean
    kind?: string
  }
  mapper?: (data: any) => T
}

export const useClientBillsTotalizer = <T,>({
  filters: { clientId, branchId, status, openedAt, closedAt, requiresAttention, kind, showDescendants },
  mapper = Mapper.default<T>(),
}: UseClientBillsTotalizerProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['companyBillsTotalizer', clientId, branchId, status, openedAt, closedAt, requiresAttention, kind, showDescendants],
    queryFn: () => {
      return privateAxios.get(`/billing/bills/client_bills_totalizer`, {
        params: {
          'q[company_id_eq]': clientId,
          'q[opened_at_gteq]': openedAt,
          'q[closed_at_lteq]': closedAt,
          'q[status_eq]': status,
          'q[branch_id_eq]': branchId,
          'q[company_kind_eq]': kind,
          'q[show_from_descendants]': showDescendants,
          'q[requires_attention]': requiresAttention,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}